import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { copyFor, routes } from 'config';
import FlowersGraphic from '/images/settings-page/big-little-flowers.svg';
import { Grid, Page, CenterColumnGridCell, InvisibleHeading } from 'styles';
import { Banner } from 'components/modules/modules.styles';
import { AccountSettingsActive } from 'pages/settings/components/account-settings';
import { UserSettingsActive } from 'pages/settings/components/user-settings';
import { Membership } from 'pages/settings/secondary/membership';
import { Nickname } from 'pages/settings/secondary/membership/nickname';
import { AccountNickname } from 'pages/settings/secondary/account-nickname';
import { LanguagePreference } from 'pages/settings/secondary/language-preference';
import { PersonalInformation } from 'pages/settings/secondary/personal-information';
import { Contracts } from 'pages/settings/secondary/contracts';
import { PersonalizedContract } from 'pages/settings/secondary/contracts/personalized-contract';
import { Name } from 'pages/settings/secondary/personal-information/name';
import { UtilitySync } from 'pages/settings/secondary/utility-sync';
import { EditLogin } from 'pages/settings/secondary/personal-information/edit-login';
import { SmsPreference } from 'pages/settings/secondary/personal-information/sms-preference';
import { UtilitySyncEdit } from 'pages/settings/secondary/utility-sync/utility-sync-edit';
import { UtilitySyncCredential } from 'pages/settings/secondary/utility-sync/utility-sync-credential';
import { PaymentMethods } from 'pages/settings/secondary/payment-methods';
import { PaymentMethodUpdate } from 'pages/settings/secondary/payment-methods/secondary/payment-method-update';
import { Moving } from 'pages/settings/secondary/moving';
import { Referrals } from 'pages/settings/secondary/referrals';
import { AccountDetails } from 'pages/settings/secondary/account-details';
import { HeroGridCell, StyledSVG } from 'pages/settings/settings.style';
import { PaymentMethod } from 'pages/settings/secondary/payment-methods/secondary/payment-method';
import { CheckLmiEligibility } from '../secondary/lmi-eligibility';
import { LmiContractForm } from '../secondary/lmi-eligibility/lmi-contract-form.page';

const routeTemplates = routes();
const getCopy = copyFor('settings');

interface Props {
  isWhale: boolean;
}

const Settings = ({ isWhale }: Props) => {
  return (
    <Page small={{ padding: '0px' }}>
      <Grid width="100%" gap="24px">
        <HeroGridCell>
          <Banner flex justifyContent="center" color="primaryInverse">
            <StyledSVG
              width="100.62px"
              src={FlowersGraphic}
              aria-hidden="true"
            />
          </Banner>
        </HeroGridCell>
        <CenterColumnGridCell>
          <InvisibleHeading tag="h1" textStyle="heading700">
            {getCopy('title')}
          </InvisibleHeading>
          <AccountSettingsActive />
          <UserSettingsActive isWhale={isWhale} />
        </CenterColumnGridCell>
      </Grid>
    </Page>
  );
};

export const Active = ({ isWhale }: Props) => {
  return (
    <Switch>
      <Route
        path={routeTemplates.accountNickname}
        component={AccountNickname}
      />
      <Route path={routeTemplates.accountDetails} component={AccountDetails} />
      <Route exact path={routeTemplates.contracts} component={Contracts} />
      <Route
        path={routeTemplates.personalizedContract}
        component={PersonalizedContract}
      />
      <Route path={routeTemplates.planNickname} component={Nickname} />
      <Route path={routeTemplates.plans} component={Membership} />
      <Route path={routeTemplates.name} component={Name} />
      <Route path={routeTemplates.editLogin} component={EditLogin} />
      <Route path={routeTemplates.smsPreference} component={SmsPreference} />
      <Route
        path={routeTemplates.lmiContractForm}
        component={LmiContractForm}
      />
      <Route
        path={routeTemplates.checkLmiEligibility}
        component={CheckLmiEligibility}
      />
      <Route
        path={routeTemplates.personalInformation}
        component={PersonalInformation}
      />
      <Route
        path={routeTemplates.languagePreference}
        component={LanguagePreference}
      />
      <Route
        path={routeTemplates.utilitySyncCredential}
        component={UtilitySyncCredential}
      />
      <Route
        path={routeTemplates.utilitySyncEdit}
        component={UtilitySyncEdit}
      />
      <Route path={routeTemplates.utilitySync} component={UtilitySync} />
      <Route
        path={routeTemplates.paymentMethodUpdate}
        component={PaymentMethodUpdate}
      />
      <Route path={routeTemplates.paymentWallet} component={PaymentMethods} />
      <Route path={routeTemplates.paymentSettings} component={PaymentMethods} />
      <Route path={routeTemplates.paymentMethod} component={PaymentMethod} />
      <Route path={routeTemplates.payment} component={PaymentMethods} />
      <Route path={routeTemplates.moving} component={Moving} />
      <Route path={routeTemplates.referrals} component={Referrals} />
      <Route
        path={routeTemplates.settings}
        render={props => <Settings {...props} isWhale={isWhale} />}
      />
      <Redirect to={routeTemplates.settings} />
    </Switch>
  );
};
